import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import {
  StyledHeader,
  StyledTableHead,
  StyledIcon,
} from './CrewListHeader.styled';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const CrewListHeader = () => {
  const [toggle, setToggle] = useState(false);

  const redirectToLearnPage = () =>
    window.open(
      'http://learn.studio.cvent.com/en/articles/1067125-crew-permission-levels',
      '_blank',
    );

  const changeToggleState = () => setToggle(!toggle);

  return (
    <StyledTableHead>
      <StyledHeader>User</StyledHeader>

      <StyledHeader>Tool(s)</StyledHeader>

      <StyledHeader
        id="tip-permission"
        data-testid="tip-permission-tooltip"
        onClick={redirectToLearnPage}
      >
        <Tooltip
          placement="top"
          isOpen={toggle}
          autohide={false}
          target="tip-permission"
          toggle={changeToggleState}
          style={{ cursor: 'pointer' }}
        >
          Choose between a Read Only, Contributor, Admin, or Show caller
          permission. Click to learn about more permissions.
        </Tooltip>
        <span>Permission</span>
        <StyledIcon icon={faExclamationCircle} />
      </StyledHeader>
    </StyledTableHead>
  );
};

export default CrewListHeader;
